import canPlayOriginalVideo from '@anm/helpers/canPlayOriginalVideo';
import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';

var checkContainMedia = function checkContainMedia(_ref) {
  var type = _ref.type,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      supportedExtensions = _ref.supportedExtensions;

  var isVideo = function isVideo(item) {
    return item.type === 'video';
  };

  var isImage = function isImage(item) {
    return item.type === 'image';
  };

  var isAudio = function isAudio(item) {
    return item.type === 'audio';
  };

  if (type === 'image') return !!list.filter(function (item) {
    return isImage(item);
  }).length;
  if (type === 'audio') return !!list.filter(function (item) {
    return isAudio(item);
  }).length;

  var isSupported = function isSupported(video) {
    var ext = getExtensionFromPath(video.path);
    return ext && supportedExtensions.includes(ext.toLowerCase());
  };

  var allVideos = list.filter(function (item) {
    return isVideo(item);
  });
  var canPlayOriginal = allVideos.length && canPlayOriginalVideo(allVideos);
  var canPlayNotOriginal = !!allVideos.filter(function (v) {
    return !v.isOriginal && isSupported(v);
  }).length;
  var canPlay = canPlayOriginal || canPlayNotOriginal;
  return canPlay;
};

export default checkContainMedia;